// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2a2Jg","header":"PatientQuestionnaire_header__n8UMt","info":"PatientQuestionnaire_info__2rRud"};